(() => {
  const button = document.getElementById('hanso-back-to-top');
  if (!button || button.dataset.bound === 'true') return;
  button.dataset.bound = 'true';
  const page = document.querySelector('.page-wrapper');
  let framePending = false;
  let directionPosition = Math.max(window.scrollY, page?.scrollTop || 0);
  button.dataset.scrollDirection = 'down';
  const update = () => {
    const position = Math.max(window.scrollY, page?.scrollTop || 0);
    button.hidden = position < Math.max(400, window.innerHeight * 0.75);
    const delta = position - directionPosition;
    if (button.hidden) {
      button.dataset.scrollDirection = 'down';
      directionPosition = position;
    } else if (Math.abs(delta) >= 3) {
      button.dataset.scrollDirection = delta > 0 ? 'down' : 'up';
      directionPosition = position;
    }
    framePending = false;
  };
  const schedule = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  page?.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', update);
  button.addEventListener('click', () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reducedMotion ? 'instant' : 'smooth';
    page?.scrollTo({ top: 0, left: page.scrollLeft, behavior });
    window.scrollTo({ top: 0, left: window.scrollX, behavior });
    document.querySelector('#header-group a[href]')?.focus({ preventScroll: true });
  });
  update();
})();
